import React, { useEffect, useState } from "react";
import PageHeader from "../PageHeader";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { useParams } from "react-router-dom";

export default function UserAccessManagementComponent() {
  const [fireFightingObjects, setFireFightingObjects] = useState([]);
  const [selectedFireFightingObject, setSelectedFireFightingObject] =
    useState("");
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectList(
        "1",
        ""
      );
      if (status === true) {
        setFireFightingObjects(data);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  const getData = (id) => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectUsers(id);
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeFireFightingObject = (e) => {
    const value = e.target.value;
    setSelectedFireFightingObject(value);

    if (value !== "") {
      getData(value);
    } else {
      setDataSource([]);
    }
  };

  const handleChangeAccessPermission = (e, userId, userName) => {
    const value = e.target.checked;

    if (window.confirm(`${userName} 님의 접속권한을 변경하시겠습니까?`)) {
      apiWrapper(async () => {
        const { status, data } =
          await fireonApi.setFireFightingObjectUserAccessPermission(
            selectedFireFightingObject,
            userId,
            value
          );
        alert(`${data}`);

        //설정 성공 시 새로고침
        if (status === true) {
          getData(selectedFireFightingObject);
        }
      });
    }
  };

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="사용자 접속 관리" isUseMenu={false} />
      <div class="container pb-40">
        <div class="input-wrap">
          <div class="input-item">
            <p class="input-title">소방대상물</p>
            <div class="select-wrap">
              <select
                value={selectedFireFightingObject}
                onChange={handleChangeFireFightingObject}
              >
                <option value="" selected disabled>
                  소방대상물을 선택해주세요.
                </option>
                {fireFightingObjects.length > 0 &&
                  fireFightingObjects.map((item) => (
                    <option key={item.id} name={item.id} value={item.id}>
                      {item.buildingName}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        <div class="tableList accessManagementlist">
          <div class="config-row title-row">
            <div class="title-txt config-title">사용자 정보</div>
            <div class="title-txt config-switch">차단/허용</div>
          </div>
          <div class="config-row-wrap">
            {dataSource.length > 0 &&
              dataSource.map((item, index) => (
                <div class="config-row">
                  <div class="config-title">
                    <div class="config-title-top">
                      <p class="user-title">{item.name}</p>
                      <p class="user-info">{item.userType}</p>
                    </div>
                    <p class="user-num">{item.contact}</p>
                  </div>
                  <div class="config-switch">
                    <label class="switch">
                      <input
                        type="checkbox"
                        checked={item.accessPermission}
                        onChange={(e) =>
                          handleChangeAccessPermission(e, item.id, item.name)
                        }
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
